var LEAD_VALUE = 50
window.LEAD_VALUE = 50
window.LEAD_VALUE_SCORE = 50

LEAD_VALUE_FB = 10
window.LEAD_VALUE_FB = 10


if (window.location.href.includes('?staff_user')) {
	localStorage.setItem('staff_user', 'true');
}

if (localStorage.getItem('fbclid') == null && new URLSearchParams(location.search).get('fbclid')) {
	localStorage.setItem('fbclid', new URLSearchParams(location.search).get('fbclid'))
}

if (localStorage.getItem('msclkid') == null && new URLSearchParams(location.search).get('msclkid')) {
	localStorage.setItem('msclkid', new URLSearchParams(location.search).get('msclkid'))
}


// try {
// 	const private_domain_em = /google|gmail|mail.de|hotmail|yahoo|outlook|gmail\.com|web|aol|icloud|gmx|freenet|t-online|online|neoneverglow|protonmail|sunrise|bluewin|me\.de/i;
// } catch (error) {

// }
// jQuery.event.trigger('globo_form_submit');



// const private_domains = [
//     'gmail', 'hotmail', 'yahoo', 'outlook', 'gmail\\.com', 'web', 'aol', 
//     'icloud', 'gmx', 'freenet', 't-online', 'online', 'neoneverglow', 
//     'protonmail', 'sunrise', 'bluewin', 'me\\.de'
// ];
// const private_domain_pattern = new RegExp(private_domains.join('|'), 'i');

__lv = {};


var _lv__prices = {
	'Wiederverkauf': 100,
	'Gewerblich': 100,
	'Privat': 40,
	'company_name': 15,
	'company_email': 20,

	'Google': 20,
	'Instagram': 10,
	'other': 10,
	'other_source': 10,


	'gclid': 10,
	'fbclid': 5,

	'referral': 15,
	'social': 10
};


$(document).on('globo.form.loaded', function () {

	// console.log('formloaded');
	handle_lv();

});

$(document).ready(function () {

	if (localStorage.getItem('fbclid') == null && new URLSearchParams(location.search).get('fbclid')) {
		localStorage.setItem('fbclid', new URLSearchParams(location.search).get('fbclid'))
	}

	jQuery('form.g-container input, form.g-container select').off('change', handle_lv);
	jQuery('form.g-container input, form.g-container select').on('change', handle_lv);
	setTimeout(() => {
		jQuery('form.g-container input, form.g-container select').off('change', handle_lv);
		jQuery('form.g-container input, form.g-container select').on('change', handle_lv);
	}, 15000);
	setTimeout(() => {
		jQuery('form.g-container input, form.g-container select').off('change', handle_lv);
		jQuery('form.g-container input, form.g-container select').on('change', handle_lv);
	}, 5000);


})


function handle_lv() {
	// console.log('handlelv');
	// ['handle_lv_fb', 'handle_lv_gads'].forEach(function (element) {
	['handle_lv_gads', 'handle_lv_fb',].forEach(function (element) {
		try {
			if (typeof window[element] === 'function') {
				window[element]();
			}
		} catch (error) {
			// console.error('Error calling', element, ':', error);
		}
	});
}


function check_form_good() {
	var fieldsForm = JSON.parse($('[name=_keyLabel]').val());
	$('form.g-container').first().serializeArray().forEach(function (f) {
		var label = fieldsForm[f.name] || f.name;
		if (/e?mail/i.test(label) && f.value.includes('@')) {
			label = 'e.mail';
		}
		label = label.toLowerCase();
		// console.log(f)
		fieldsForm[label] = f.value;
		delete fieldsForm[f.name];
	});
	// console.table(fieldsForm);

	if (!fieldsForm['name'] || !fieldsForm['e.mail']) {
		return false;
	}
	window.form_data_ = fieldsForm;


	if (form_data_['e.mail']) window.LEAD_email = form_data_['e.mail'];
	if (form_data_.telefonrufnummer) window.LEAD_phone = form_data_.telefonrufnummer.startsWith('+') ? form_data_.telefonrufnummer : '+' + form_data_.telefonrufnummer.replace(/\D/g, '').replace(/^0/, '49').replace(/^49/, '49');

	return true;
}


function handle_lv_gads() {
	try {
		if ($('#fbclid').length == 0) {
			glob_form = JSON.parse($('[name=_keyLabel]').val());
			glob_form['fbclid'] = 'fbclid'
			$('[name=_keyLabel]').val(JSON.stringify(glob_form))
			$('[name=_keyLabel]').after(` <input type="hidden" data-type="fixed" id="fbclid" name="fbclid" value="">`);
		}
		if (localStorage.getItem('fbclid') && document.querySelector("[id^='globo-formbuilder'] #fbclid")) {
			document.querySelector("[id^='globo-formbuilder'] #fbclid").value = localStorage.getItem('fbclid');
		};

		if ($('#msclkid').length == 0) {
			glob_form = JSON.parse($('[name=_keyLabel]').val());
			glob_form['msclkid'] = 'msclkid'
			$('[name=_keyLabel]').val(JSON.stringify(glob_form))
			$('[name=_keyLabel]').after(` <input type="hidden" data-type="fixed" id="msclkid" name="msclkid" value="">`);
		}
		if (localStorage.getItem('msclkid') && document.querySelector("[id^='globo-formbuilder'] #msclkid")) {
			document.querySelector("[id^='globo-formbuilder'] #msclkid").value = localStorage.getItem('msclkid');
		};

		if ($('#lead_source').length == 0) {
			const $key = $('[name=_keyLabel]');
			const globForm = JSON.parse($key.val() || '{}');
			globForm.lead_source = 'lead_source';
			$key.val(JSON.stringify(globForm));
			window.lead_source = JSON.stringify(window.getTrackingData());
			$('<input>', { type: 'hidden', 'data-type': 'fixed', id: 'lead_source', name: 'lead_source', value: window.lead_source }).insertAfter($key);
			console.log($('#lead_source').val())
		}
		
		if ($('#lead_campaign').length == 0) {
			const $key = $('[name=_keyLabel]');
			const globForm = JSON.parse($key.val() || '{}');
			globForm.lead_campaign = 'lead_campaign';
			$key.val(JSON.stringify(globForm));
			window.lead_campaign = JSON.stringify(window.getTrackingData().utm_campaign);
			$('<input>', { type: 'hidden', 'data-type': 'fixed', id: 'lead_campaign', name: 'lead_campaign', value: window.lead_campaign }).insertAfter($key);
			console.log($('#lead_campaign').val())
		}

		
		if ($('#uuid').length == 0) {
			glob_form = JSON.parse($('[name=_keyLabel]').val());
			glob_form['uuid'] = 'uuid'
			$('[name=_keyLabel]').val(JSON.stringify(glob_form))
			window._uuid = _getDeviceFingerprint();
			$('[name=_keyLabel]').after(` <input type="hidden" data-type="fixed" id="uuid" name="uuid" value="${window._uuid}">`);
		}


	} catch (error) {

	}
	try {
		if (localStorage.getItem('gclid') && document.querySelector("[id^='globo-formbuilder'] span[data-label='gclid']")) {
			document.querySelector("[id^='globo-formbuilder'] #hidden-1").value = localStorage.getItem('gclid');
		};
		// if (localStorage.getItem('fbclid') && document.querySelector("[id^='globo-formbuilder'] span[data-label='fbclid']")) {
		// 	document.querySelector("[id^='globo-formbuilder'] #hidden-2").value = localStorage.getItem('fbclid');
		// };
	} catch (error) {

	}

	try {
		if (!check_form_good()) {
			return;
		}

		var $form = jQuery('form.g-container').first();
		var formData = $form.serializeArray();

		var lead_val = 0;
		var formValues = {};
		var debug_adder = '';
		jQuery.each(formData, function (i, field) {
			try {
				var $field = jQuery(`[name="${field.name}"]`);
				var placeholder = $field.attr('placeholder') || '';

				key = field.name + ' ' + placeholder
				value = field.value;
				if (value.includes('@')) {

					var private_domain_em = /google|gmail|mail.de|hotmail|yahoo|outlook|gmail\.com|web|aol|icloud|gmx|freenet|t-online|online|neoneverglow|protonmail|sunrise|bluewin|me\.de/i;
					if (private_domain_em.test(value)) {
						_lv__prices['Gewerblich'] = _lv__prices['Wiederverkauf'] = 85;
					} else {
						_lv__prices['Gewerblich'] = _lv__prices['Wiederverkauf'] = 130;
					}
					// console.log(key, value, _lv__prices['Gewerblich']);

				}

			} catch (error) {
				// console.log(error);

			}
		});


		jQuery.each(formData, function (i, field) {
			try {

				var $field = jQuery(`[name="${field.name}"]`);
				var placeholder = $field.attr('placeholder') || '';



				key = field.name + ' ' + placeholder
				value = field.value;
				formValues[key] = field.value;
				adder = 0
				if ($field.attr('type') === 'hidden') {
					return true; // continue to next iteration
				}

				var private_domain_em = /google|gmail|mail.de|hotmail|yahoo|outlook|gmail\.com|web|aol|icloud|gmx|freenet|t-online|online|neoneverglow|protonmail|sunrise|bluewin|me\.de/i;

				if (/@|email|e-mail/i.test(key) && /@/i.test(value) && !/(google|gmail|hotmail|yahoo|outlook|gmail.com|web|hotmail|yahoo|aol|icloud|gmx|freenet|t-online|online|neoneverglow)/i.test(value)) {
					adder = _lv__prices.company_email
				} else {

				}

				if (/Unterneh|Unternehmensname/i.test(key) && value.length > 0) {
					adder = _lv__prices.company_name
				}

				// if (_lv__prices[value]) {
				// 	adder = _lv__prices[value]
				// }
				Object.keys(_lv__prices).forEach(keyyss_ => {
					if (new RegExp(keyyss_).test(value)) {
						adder += _lv__prices[keyyss_];
						// console.log(keyyss_, _lv__prices[keyyss_]);
					}
				});
				lead_val += adder

				if (adder > 0) {
					// console.info('adder:', adder, key, value);
					debug_adder += ` | ${value} = ${adder}`;
				}
			} catch (error) {
				// console.error('Error:', error);
			}
		});

		if (localStorage.getItem('gclid') || new URLSearchParams(location.search).get('gclid')) {
			lead_val += _lv__prices.gclid;
			debug_adder += ` | gclid = ${_lv__prices.gclid}`;

		}
		if (localStorage.getItem('fbclid') || new URLSearchParams(location.search).get('fbclid')) {
			lead_val += _lv__prices.fbclid;
			debug_adder += ` | fbclid = ${_lv__prices.fbclid}`;
		}

		if (new RegExp('google|instagram', 'i').test(JSON.stringify(formData)) == false) {
			lead_val += _lv__prices.other;
			debug_adder += ` | other_source = ${_lv__prices.other}`;

		}

		// console.debug('lead_val:', lead_val);
		lead_val_ = lead_val

		if (lead_val > 30) {
			window.LEAD_VALUE_SCORE = lead_val
			lead_val = lead_val / 5
			lead_val = 1
			LEAD_VALUE = lead_val
			window.LEAD_VALUE = lead_val
		}


		var lead_val_q = 50
		if (window.LEAD_VALUE_SCORE >= 165) {
			lead_val_q = 40;
			lead_val_q = 50;
			lead_val_q = 100;
		}
		if (window.LEAD_VALUE_SCORE >= 106) {
			lead_val_q = 20;
			lead_val_q = 30;
			lead_val_q = 150;
		}

		page_title = $('[name="page[title]"]').val().split('|ga')[0] + " |ga " + `${lead_val_q}_${lead_val_}` + " €"

		$('[name="page[title]"]').val(page_title);

		if (new URLSearchParams(location.search).get('dd') != null) {
			$('h1').html(`💶 Lead Value: ${debug_adder} ====> ${window.LEAD_VALUE_SCORE}`);
		}


	} catch (error) {
		// console.log(error)

	}

}


// Don't override push at all - use a completely non-invasive observer
(function () {
	let processing = false;
	// Create a safe observer that doesn't modify anything
	const observePush = () => {
		const originalPush = Array.prototype.push;
		const dataLayer = window.dataLayer;

		if (!dataLayer || dataLayer._observed) return;

		// Store original method
		const superPush = dataLayer.push.bind(dataLayer);

		// Add lightweight listener
		dataLayer.push = function (...items) {
			items.forEach(item => {
				if (item && item[0] === 'event' && item[1] === 'globo_form_submit') {
					// console.log('Detected globo_form_submit');
					if (!processing) {
						processing = true;
						Promise.resolve().then(() => {
							try { fire_tags_(); }
							catch (e) { console.error(e); }
							finally { processing = false; }
						});
					}
				}
			});
			return superPush(...items);
		};

		dataLayer._observed = true;
	};

	if (window.dataLayer) {
		observePush();
	} else {
		const originalDefine = Object.defineProperty;
		Object.defineProperty(window, 'dataLayer', {
			configurable: true,
			set: function (val) {
				originalDefine.call(window, 'dataLayer', { value: val, configurable: true });
				observePush();
			}
		});
	}
})();

function fire_tags_() {
	// console.log('globo_form_submit');

	// dataLayer.push({
	// 	event: 'generate_lead',
	// 	value: window.LEAD_VALUE,
	// 	currency: 'EUR'
	// });

	var leadData = {
		// value: window.LEAD_VALUE_FB,
		// currency: 'EUR',
		lead_type: 'lead_form',
		event_id: 'lead_' + Date.now()  // Uncomment for deduplication
	};

	// Add only email, phone, name if they exist in form_data
	if (window.form_data_ && typeof window.form_data_ === 'object') {
		const form = window.form_data_;

		// Only include these 3 fields if they have values
		if (form['e.mail']) leadData.email = form['e.mail'];
		if (form.telefonrufnummer) leadData.phone = form.telefonrufnummer;
		if (form.name) leadData.name = form.name;

	}

	// Fire the event
	fbq('track', 'Lead', leadData);


	// leadData['value'] = window.LEAD_VALUE_FB;
	// leadData['currency'] = 'EUR';

	let uetData = {};
	if (leadData.email) uetData.em = leadData.email;
	if (leadData.phone) uetData.ph = leadData.phone;

	// Add conversion value and currency from leadData
	// if (leadData.value) uetData.revenue_value = leadData.value;
	// if (leadData.currency) uetData.currency = leadData.currency;

	// Only push to UET if we have at least one piece of data
	if (Object.keys(uetData).length > 0) {
		window.uetq.push('set', { 'pid': uetData });
	}
	window.uetq = window.uetq || [];
	window.uetq.push("event", "submit_lead_form", {
		// "revenue_value": leadData.value,
		// "currency": leadData.currency || "EUR" // fallback only for currency if needed
	});
	// fbq('track', 'Lead', {
	// 	value: window.LEAD_VALUE_FB,
	// 	currency: 'EUR',
	// 	lead_type: 'lead_form'
	// 	// event_id: 'lead_' + Date.now()     
	// });

}

// document.addEventListener('globo_form_submit', function () {
// gtag("event", "conversion", {
//     send_to: "AW-360647873/5nkmCPaGjbkCEMGZ_KsB",
//     value: window.LEAD_VALUE,
//     currency: "EUR"
// });
// });

// $(document).on('globo_form_submit', function () {
// 	console.log('fired');
// 	if (window.LEAD_VALUE_FB > 0) {
// 		fbq('track', 'Lead', {
// 			value: window.LEAD_VALUE_FB,
// 			currency: 'EUR',
// 			lead_type: 'lead_form'
// 			// event_id: 'lead_' + Date.now()     
// 		});
// 	}
// 	if (typeof fbq === 'function') {
// 	}
// });


// gtag('event', 'globo_form_submit', {});

// document.dispatchEvent(new Event('globo_form_submit'))
// jQuery.event.trigger('globo_form_submit');

$(document).on('globo_form_submit', function () {
	// gtag("event", "conversion", {
	//     send_to: "AW-360647873/5nkmCPaGjbkCEMGZ_KsB",
	//     value: window.LEAD_VALUE,
	//     currency: "EUR",
	//     transaction_id: "lead-" + Date.now()
	// });
	// gtag("event", "generate_lead", {
	//     send_to: "G-2S4PK435D5",
	//     value: window.LEAD_VALUE,
	//     currency: "EUR"
	// });
});


// "lead-" + Date.now()




/**
 * 
Leadwerte für Meta:Privat: 20€
Gewerblich: 60 €
Wiederverkauf: 60€
company_name: +20 €
company_email: +25 €
Private email : 0€



Privat: 20,
Wiederverkauf: 60,
Gewerblich: 60,
company_name: 20,
company_email: 20


*/

var _lv__prices_fb = {
	Privat: 20,
	Wiederverkauf: 60,
	Gewerblich: 60,
	company_name: 20,
	company_email: 20,
	gclid: 0,      // Added missing property
	fbclid: 0,     // Added missing property
	other: 0       // Added missing property
};

function handle_lv_fb() {
	try {
		if (!check_form_good()) {
			return;
		}

		var $form = jQuery('form.g-container').first();
		var formData = $form.serializeArray();
		// console.log(formData)

		var lead_val = 0;
		var formValues = {};
		var debug_adder = '';


		// Second loop to calculate lead value
		jQuery.each(formData, function (i, field) {
			try {
				var $field = jQuery(`[name="${field.name}"]`);
				var placeholder = $field.attr('placeholder') || '';
				var key = field.name + ' ' + placeholder;
				var value = field.value;
				formValues[key] = field.value;
				var adder = 0;

				if ($field.attr('type') === 'hidden') {
					return true; // continue to next iteration
				}

				var private_domain_em = /google|gmail|mail.de|hotmail|yahoo|outlook|gmail\.com|web|aol|icloud|gmx|freenet|t-online|online|neoneverglow|protonmail|sunrise|bluewin|me\.de/i;

				if (/@|email|e-mail/i.test(key) && value && /@/i.test(value) && !private_domain_em.test(value)) {
					adder = _lv__prices_fb.company_email;
				}

				if (/Unterneh|Unternehmensname/i.test(key) && value && value.length > 0) {
					adder = _lv__prices_fb.company_name;
				}

				// Check if value matches any price keys
				Object.keys(_lv__prices_fb).forEach(function (keyyss_) {
					if (new RegExp(keyyss_, 'i').test(value)) {
						adder += _lv__prices_fb[keyyss_];
						// console.log(keyyss_, _lv__prices_fb[keyyss_]);
					}
				});

				lead_val += adder;

				if (adder > 0) {
					// console.info('adder:', adder, key, value);
					debug_adder += ' | ' + value + ' = ' + adder;
				}
			} catch (error) {
				// console.error('Error:', error);
			}
		});

		// Check for gclid parameter
		if (localStorage.getItem('gclid') || new URLSearchParams(location.search).get('gclid')) {
			lead_val += _lv__prices_fb.gclid || 0;
			debug_adder += ' | gclid = ' + (_lv__prices_fb.gclid || 0);
		}

		// Check for fbclid parameter
		if (localStorage.getItem('fbclid') || new URLSearchParams(location.search).get('fbclid')) {
			lead_val += _lv__prices_fb.fbclid || 0;
			debug_adder += ' | fbclid = ' + (_lv__prices_fb.fbclid || 0);
		}

		// Check for other sources
		if (!new RegExp('google|instagram', 'i').test(JSON.stringify(formData))) {
			lead_val += _lv__prices_fb.other || 0;
			debug_adder += ' | other_source = ' + (_lv__prices_fb.other || 0);
		}

		// console.debug('lead_val:', lead_val);


		lead_val_ = lead_val
		if (lead_val > 20) {
			lead_val = lead_val / 5
			window.LEAD_VALUE_FB = lead_val;
		}


		var leadValueGA = window.LEAD_VALUE_SCORE;
		var score = leadValueGA <= 105 ? 5
			: leadValueGA <= 165 ? 10
				: leadValueGA > 165 ? 15
					: 0;

		lead_val_ = leadValueGA;
		lead_val = score;
		window.LEAD_VALUE_FB = score;

		lead_val = 0

		page_title = $('[name="page[title]"]').val().split('|fb')[0] + " |fb " + `${lead_val}_${lead_val_}` + " €"
		$('[name="page[title]"]').val(page_title);

		//  save bing title value 
		page_title = $('[name="page[title]"]').val().split('|bing')[0] + " |bing " + `${lead_val}_${lead_val_}` + " €"
		$('[name="page[title]"]').val(page_title);

		if (new URLSearchParams(location.search).get('ddfb') != null) {
			$('h1').html('💶 Lead Value: ' + debug_adder + ' ==> ' + lead_val + page_title);
		}
	} catch (error) {
		// console.log(error);
	}
}











/**

window.fbq = window.fbq || function () {
	window.fbq.callMethod
		? window.fbq.callMethod.apply(window.fbq, arguments)
		: window.fbq.queue.push(arguments);
};

const originalFbq = window.fbq;


window.fbq = function () {
	try {
		const args = arguments;

		const type = args[0];
		const event = args[1];
		const data = args[2];

		const hasContentName =
			data && typeof data === 'object' && 'content_name' in data;

		if (type === 'track' && event === 'Lead' && hasContentName) {
			// console.log('Blocked Lead with content_name');
			// return;
			args[2] = {
				...data,
				value: window.LEAD_VALUE_FB,
				currency: 'EUR',
				lead_type: 'lead_form'
			};
			
		}
		console.log(args);

		return originalFbq.apply(this, args);
	} catch (e) {
		return undefined;
	}
};

 
 fbq("track", "Lead", {
								content_name: 'ttt',
								page_location: Globo.FormBuilder.page.href,
								page_title: Globo.FormBuilder.page.title
							}, {
								eventID: 1111
							})

							
 */




function _getDeviceFingerprint() {
	// Collect device information
	var data = [
		navigator.userAgent,
		navigator.language,
		screen.width + 'x' + screen.height,
		screen.colorDepth,
		navigator.hardwareConcurrency || 'unknown',
		navigator.deviceMemory || 'unknown',
		new Date().getTimezoneOffset(),
		navigator.platform,
		navigator.vendor || 'unknown'
	].join('|||');

	// Simple hash function
	function hashCode(str) {
		var hash = 0;
		for (var i = 0; i < str.length; i++) {
			var char = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + char;
			hash = hash & hash; // Convert to 32bit integer
		}
		return hash.toString(16);
	}

	var now = new Date();
	var unixTimestamp = Math.floor(Date.now());
	console.log(unixTimestamp); // e.g., 1687951845

	uuid = `${hashCode(data).replaceAll('-', '')}_${unixTimestamp}`;
	return uuid;
}



(function () {
	// List of tracking parameters to capture
	const trackingParams = [
		'utm_source',
		'utm_medium',
		'utm_campaign',
		'utm_term',
		'utm_content',
		'utm_id',
		'gclid',        // Google Click ID
		'fbclid',       // Facebook Click ID
		'msclkid',      // Microsoft Click ID
		'ttclid',       // TikTok Click ID
		'twclid',       // Twitter Click ID
		'li_fat_id',    // LinkedIn Click ID
		'dclid',        // DoubleClick ID
		'wbraid',       // Google Web-to-App
		'gbraid',       // Google App-to-Web
		'srsltid',      // Google Merchant Center
		'epik',         // Pinterest
		'irclickid',    // Impact Radius
		'ref'           // Generic referral
	];

	const STORAGE_KEY = 'tracking_data';
	const COOKIE_DAYS = 90;

	// Cookie helpers
	function setCookie(name, value, days) {
		const expires = new Date(Date.now() + days * 864e5).toUTCString();
		document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
	}

	function getCookie(name) {
		return document.cookie.split('; ').reduce((r, v) => {
			const parts = v.split('=');
			return parts[0] === name ? decodeURIComponent(parts[1]) : r;
		}, '');
	}

	// Load existing data (prefer localStorage, fall back to cookie)
	let stored = {};
	try {
		const ls = localStorage.getItem(STORAGE_KEY);
		if (ls) stored = JSON.parse(ls) || {};
	} catch (e) { }

	if (!Object.keys(stored).length) {
		try {
			const ck = getCookie(STORAGE_KEY);
			if (ck) stored = JSON.parse(ck) || {};
		} catch (e) { }
	}

	// Read current URL params
	const urlParams = new URLSearchParams(window.location.search);
	let updated = false;

	trackingParams.forEach(param => {
		const value = urlParams.get(param);
		if (value) {
			stored[param] = value;
			updated = true;
		}
	});

	// Store landing page + referrer on first visit only
	if (urlParams.toString() || !stored.landing_page) {
		if (!stored.landing_page) {
			stored.landing_page = window.location.href;
			stored.referrer = document.referrer || 'direct';
			updated = true;
		}
	}

	// Persist if anything changed (or on first run)
	if (updated || !localStorage.getItem(STORAGE_KEY)) {
		stored.timestamp = new Date().toISOString();
		const json = JSON.stringify(stored);

		try { localStorage.setItem(STORAGE_KEY, json); } catch (e) { }
		setCookie(STORAGE_KEY, json, COOKIE_DAYS);
	}

	// Helper to read it back anywhere
	window.getTrackingData = function () {
		try {
			const ls = localStorage.getItem(STORAGE_KEY);
			if (ls) return JSON.parse(ls);
		} catch (e) { }
		try {
			const ck = getCookie(STORAGE_KEY);
			if (ck) return JSON.parse(ck);
		} catch (e) { }
		return {};
	};
})();

// var tracking = window.getTrackingData();
// console.table(tracking);
// console.log(tracking.utm_source);




if (location.pathname === '/pages/feedback') {

(function () {
  var ENDPOINT = 'https://sultan1.fyi/neon-ever-glow/index.php?__notion_sequence_fdb';
  var MAX_TRIES = 3;

  function send(attempt) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url: location.href }),
      keepalive: true            // still sends if the user leaves the page
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res;
    })
    .catch(function (err) {
      if (attempt >= MAX_TRIES) {
        console.warn('[NE] POST failed after ' + MAX_TRIES + ' tries:', err);
        return null;
      }
      var wait = 1000 * attempt;   // 1s, then 2s
      return new Promise(function (r) { setTimeout(r, wait); })
        .then(function () { return send(attempt + 1); });
    });
  }

  send(1);
})();
}





// <script>(function(w, d, t, u, o) {w[u] = w[u] || [], o.ts = (new Date).getTime();var n = d.createElement(t);n.src = "https://bat.bing.net/bat.js?ti=" + o.ti + ("uetq" != u ? "&q=" + u : ""),n.async = 1, n.onload = n.onreadystatechange = function() {var s = this.readyState;s && "loaded" !== s && "complete" !== s ||(o.q = w[u], w[u] = new UET(o), w[u].push("pageLoad"),n.onload = n.onreadystatechange = null)};var i = d.getElementsByTagName(t)[0];i.parentNode.insertBefore(n, i);})(window, document, "script", "uetq", {ti: "56373456",enableAutoSpaTracking: true});</script>